import React, { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router-dom';
import { logger } from '@flexible-reports/services/logger';
import { setStandardLayoutAllAccountChromeConfiguration } from '@urc-ui/services/aac-chrome-api';
import { ErrorCard } from '@flexible-reports/components/error-card/error-card';
import styled from 'styled-components';
import { Flex } from '@amzn/storm-ui';
import { matchesFatalPatterns } from '@flexible-reports/utils/error-utils';

const FullHeightFlex = styled(Flex)`
  height: 100%;
  margin-inline-start: -60px; // compensating for hardcoded in AAC Chrome #sc-content-container left margin that breaks pages with no side menu (https://t.corp.amazon.com/V1704758610)
`;

export const PAGE_ID_MAP: Record<string, string> = {
  '/': 'Landing',
  '/new': 'CreateNewReport',
  '/copy': 'CopyReport',
  '/history': 'ExportHistory',
  '/settings': 'Settings',
  '/analysis-workspace': 'AnalysisWorkspace',
  '*': 'Error404'
};

export const ErrorBoundary = () => {
  const error = useRouteError();
  const { pathname } = useLocation();
  const pageId = PAGE_ID_MAP[pathname] ?? PAGE_ID_MAP['*'];

  // Reset the page layout
  setStandardLayoutAllAccountChromeConfiguration({
    pageName: '',
    enableMarketplaceSwitcher: false
  });

  useEffect(() => {
    if (matchesFatalPatterns(0, error)) {
      logger.logFatalMessage(`There was an error rendering page ${pageId}`, error);
    } else {
      logger.logErrorMessage(`There was an error rendering page ${pageId}`, error);
    }
  }, [error]);

  return (
    <FullHeightFlex alignItems='flex-start' padding='large'>
      <ErrorCard />
    </FullHeightFlex>
  );
};
